export * from './tuning';
export * from './hazards';
export * from './maps';
export * from './quality';

/** Bump when anything that changes generated worlds or sim results changes. Seeds/replays are scoped to it. */
export const WORLD_VERSION = 7;

/** The game's name — menus, loading screen, share text. (index.html and the web manifest repeat it.) */
export const GAME_NAME = 'Farther';
